import { BaseModel } from 'app/core/_base/crud';
export class DatPhongHopModel extends BaseModel {
        Id_DP: number;
        Id_Phong: number;
        TenPhong:string;
        MoTa: string;
        NgayDatPhong: string;
        TuGio: string;
        DenGio: string;
        NoiDungHop: string;
        NguoiTao: number;
        TinhTrang: number;
        LyDoKhongXacNhan: string;
        LyDoHuy: string;
        TenNguoiDangKy:string;
        clear() {
                this.Id_DP = 0;
                this.Id_Phong = 0;
                this.NgayDatPhong = '';
                this.TenPhong='',
                this.MoTa = '';
                this.TuGio = '';
                this.DenGio = '';
                this.NoiDungHop = '';
                this.NguoiTao = 0;
                this.TinhTrang = 0;
                this.LyDoKhongXacNhan = '';
                this.LyDoHuy = '';
                this.TenNguoiDangKy='';
        }

        copy(item: DatPhongHopModel) {
                this.Id_DP = item.Id_DP;
                this.Id_Phong = item.Id_Phong;
                this.MoTa = item.MoTa;
                this.TenPhong=item.TenPhong;
                this.NgayDatPhong = item.NgayDatPhong;
                this.TuGio = item.TuGio;
                this.DenGio = item.DenGio;
                this.NoiDungHop = item.NoiDungHop;
                this.NguoiTao = item.NguoiTao;
                this.TinhTrang = item.TinhTrang;
                this.LyDoKhongXacNhan = item.LyDoKhongXacNhan;
                this.LyDoHuy = item.LyDoHuy;
                this.TenNguoiDangKy=item.TenNguoiDangKy;
        }

}
